import React, { useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box} from "@mui/material";
import CardWithoutPadding from "../components/CardWithoutPadding";
import DataMain from "../components/DataTable/DataMain";
import {useLocation, useNavigate} from "react-router-dom";
import { resolveLiftId, buildLiftIdUrlSync } from "../components/utils/liftRouteParams";

export default function LiftMaintenance() {
  const location = useLocation();
  const navigate = useNavigate();
  // TE-2038: state first, then ?liftId=. Reading state alone left the page blank
  // after a reload that followed a stateless navigation to this same URL.
  const liftId = resolveLiftId(location);

  // Mirror the resolved id into the query string so a reload (or a bookmarked /
  // shared link) has something to read. Replaces rather than pushes, and is a
  // no-op once the URL agrees, so it cannot loop.
  useEffect(() => {
    const sync = buildLiftIdUrlSync(location, liftId);
    if (sync) navigate(sync.to, sync.options);
  }, [liftId, location, navigate]);

  return (
    <div className="col-8">
      <Box sx={{ marginTop: "50px" }} >
        <Box>
          <Grid xs={12} lg={12} xl={12}>
            <CardWithoutPadding>
              <DataMain liftId={liftId}/>
            </CardWithoutPadding>
          </Grid>
        </Box>
      </Box>
    </div>
  );
}
